'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactRedux = require('react-redux');

var _support = require('helpers/support');

var _lodash = require('lodash');

var _FirebaseAuth = require('helpers/FirebaseAuth');

var _FirebaseAuth2 = _interopRequireDefault(_FirebaseAuth);

var _AnalyticService = require('helpers/AnalyticService');

var _AnalyticService2 = _interopRequireDefault(_AnalyticService);

var _localStorage = require('utils/localStorage');

var _components = require('components');

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _user = require('redux/modules/user');

var userActions = _interopRequireWildcard(_user);

var _analytics = require('redux/modules/analytics');

var analyticsActions = _interopRequireWildcard(_analytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const CAMPAIGN_FIELD = ['name', 'typeVoucher', 'code', 'startDate', 'endDate', 'condition', 'userUsed'];
var StepThree = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    provinces: state.address.provinces,
    districts: state.booking.districts,
    provinceActive: state.booking.provinceActive,
    districtActive: state.booking.districtActive,
    addressActive: state.booking.addressActive,
    submit: state.booking.submit,
    pricing: state.booking.pricing,
    bookingSuccess: state.booking.bookingSuccess,
    bookingError: state.booking.bookingError,
    updateUserSuccess: state.user.success,
    updateUserError: state.user.updateUserError,
    user: state.auth.user,
    ANALYTIC_EXTRA: state.analytics.ANALYTIC_EXTRA
  };
}, {
  changeContact: bookingActions.changeContact,
  submitBooking: bookingActions.submitBooking,
  changeBooking: bookingActions.changeBooking,
  loginVerifyBooking: authActions.loginVerifyBooking,
  activePhone: userActions.activePhone,
  loadAuth: authActions.loadAuth,
  changeProvinceBooking: bookingActions.changeProvinceBooking,
  changeDistrictBooking: bookingActions.changeDistrictBooking,
  changeAddressBooking: bookingActions.changeAddressBooking,
  loadDistrictBooking: bookingActions.loadDistrictBooking,
  manualTrack: analyticsActions.manualTrack
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(StepThree, _Component);

  function StepThree() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, StepThree);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepThree.__proto__ || (0, _getPrototypeOf2.default)(StepThree)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showInfo: false,
      info: {
        title: {},
        message: [],
        button: [],
        closeButton: true
      },
      backdrop: false,
      showBill: false,
      FooterUI: {
        btnLabel: 'XÁC NHẬN'
      },
      previewData: { shop: {}, time: [], slot: [], services: [], note: [] }
    }, _this.hideBill = function () {
      _this.setState({ showBill: false });
    }, _this.showBill = function () {
      _this.setState({ showBill: true });
    }, _this.hideInfo = function () {
      _this.setState({ showInfo: false });
    }, _this.showInfo = function () {
      _this.setState({ showInfo: true });
    }, _this.onChangeContact = function (key, value) {
      var _this$props = _this.props,
          info = _this$props.submit.userInfo,
          changeContact = _this$props.changeContact;

      var userInfo = (0, _extends3.default)({}, info);
      value.trim();
      userInfo[key] = value;
      changeContact(userInfo);
    }, _this.nextStep = function () {
      var _this$props2 = _this.props,
          submitBooking = _this$props2.submitBooking,
          ANALYTIC_EXTRA = _this$props2.ANALYTIC_EXTRA;
      var _this$props$submit = _this.props.submit,
          shop = _this$props$submit.shop,
          bookingTimeId = _this$props$submit.bookingTimeId,
          code = _this$props$submit.code,
          slot = _this$props$submit.slot,
          noteByUser = _this$props$submit.noteByUser,
          userInfo = _this$props$submit.userInfo,
          address = _this$props$submit.address,
          atHome = _this$props$submit.atHome,
          province = _this$props$submit.province,
          district = _this$props$submit.district,
          bServices = _this$props$submit.bookingServices;

      if (shop && shop.mainCat === '05') {
        alert('Hiện tại các dịch vụ về Thể Dục Thể Thao chỉ được đặt lịch trên ứng dụng Lookme.');
        return;
      }
      var bookingServices = bServices.filter(function (v) {
        return v.number > 0;
      });
      bookingServices.forEach(function (service) {
        if (service.selectedOptions && service.selectedOptions.length) {
          service.selectedOptions = service.selectedOptions.map(function (option) {
            return option._id;
          });
        }
      });
      var body = {
        slot: slot,
        noteByUser: noteByUser,
        userInfo: userInfo,
        bookingTimeId: bookingTimeId,
        bookingServices: bookingServices,
        code: code,
        address: address,
        atHome: atHome,
        province: province,
        district: district,
        extra: {
          from: 'web'
        }
      };
      if (!userInfo.name || !userInfo.phone || atHome && (!province || !district || !address)) {
        var title = { text: 'Thông Báo', type: 'info' };
        var message = [{ text: 'Vui lòng điền đầy đủ thông tin liên hệ!' }];
        var info = { title: title, message: message, closeButton: true };
        _this.setState({ info: info, showInfo: true, backdrop: true });
        return;
      }
      if (ANALYTIC_EXTRA && ANALYTIC_EXTRA.analytic) {
        body.extra = (0, _extends3.default)({}, body.extra, ANALYTIC_EXTRA);
      }
      var utmData = _AnalyticService2.default.getUTM();
      if (utmData && utmData.link) {
        body.extra.utmLink = utmData.link;
      }
      console.log('submit Booking', body);
      submitBooking(body);
      _reactGa2.default.event({
        category: 'Booking',
        action: 'Submitted',
        label: '' + shop.name
      });
    }, _this.responseActivePhone = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!response) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return _this.props.activePhone(response);

              case 3:
                _context.next = 5;
                return _this.props.loadAuth();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.responsePhone = function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(response) {
        var userInfo;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                userInfo = _this.props.submit.userInfo;

                if (!response) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return _this.props.loginVerifyBooking(response, userInfo.name);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }(), _this.trackingData = function () {
      var _this$props$submit2 = _this.props.submit,
          shop = _this$props$submit2.shop,
          code = _this$props$submit2.code,
          bookingServices = _this$props$submit2.bookingServices,
          userInfo = _this$props$submit2.userInfo;

      var track = (0, _extends3.default)({
        screen: 'StepThree',
        button: 'Confirm',
        code: code,
        shopId: shop.id
      }, userInfo);
      if (bookingServices && bookingServices.length) {
        track.serviceId = bookingServices.reduce(function (result, bService) {
          return bService.number > 0 ? [].concat((0, _toConsumableArray3.default)(result), [bService.service]) : result;
        }, []);
      }
      return track;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(StepThree, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // @init Chỉ để lấy main category (chuối voãi)
      // shopData
      var _props = this.props,
          _props$submit = _props.submit,
          shop = _props$submit.shop,
          dateSelected = _props$submit.dateSelected,
          time = _props$submit.time,
          slot = _props$submit.slot,
          bookingServices = _props$submit.bookingServices,
          noteByUser = _props$submit.noteByUser,
          pricing = _props.pricing;

      var categoryTitle = shop.category && typeof shop.category === 'string' ? shop.category : 'Chăm Sóc Da, Massage';
      var shopData = { name: shop.name, category: categoryTitle };
      // const serviceText = [];
      // bookingServices.map(
      //   v => v.number > 0 && serviceText.push(`${v.name} (x${v.number})`)
      // );
      var serviceOptions = [];
      bookingServices.map(function (v) {
        var ser = {
          text: v.name + ' (x' + v.number + ')',
          selectedOptions: v.selectedOptions
        };
        if (v.number > 0) serviceOptions.push(ser);
      });
      var timeText = _support.Helper.toTimeBooking(dateSelected ? dateSelected.date : '', time ? time.time : null);
      var previewData = {
        shop: shopData,
        time: [timeText],
        slot: [slot],
        services: serviceOptions,
        note: [noteByUser],
        price: [pricing.total]
      };
      this.setState({ previewData: previewData });

      // @init Thông tin liên hệ
      var _props2 = this.props,
          user = _props2.user,
          changeContact = _props2.changeContact;

      var userInfo = {
        name: '',
        phone: ''
      };
      if (user) {
        userInfo.name = user.profile.name;
        userInfo.phone = user.phone;
      }
      changeContact(userInfo);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (!(0, _lodash.isEqual)(nextProps.provinceActive, this.props.provinceActive)) {
        this.props.loadDistrictBooking(nextProps.provinceActive.code);
      }
      if (!(0, _lodash.isEqual)(this.props.bookingError, nextProps.bookingError) && nextProps.bookingError) {
        var title = { text: 'Lỗi', type: 'error' };
        var message = [{
          text: nextProps.bookingError.message ? nextProps.bookingError.message : 'Đặt chỗ không thành công. Vui lòng thử lại.'
        }];
        var button = [{
          text: 'Thoát',
          onClick: function onClick() {
            return _this3.hideInfo();
          }
        }];
        var info = {
          title: title,
          message: message,
          button: button,
          backdrop: false,
          closeButton: true
        };
        this.setState({ info: info, showInfo: true });
      }
      if (!(0, _lodash.isEqual)(this.props.updateUserError, nextProps.updateUserError) && nextProps.updateUserError) {
        var _title = { text: 'Lỗi kích hoạt tài khoản', type: 'error' };
        var _message = [{
          text: nextProps.updateUserError.message ? nextProps.updateUserError.message : 'Kích hoạt tài khoản thất bại.'
        }];
        var _button = [{
          text: 'Thoát',
          onClick: function onClick() {
            return _this3.hideInfo();
          }
        }];
        var _info = {
          title: _title,
          message: _message,
          button: _button,
          backdrop: false,
          closeButton: true
        };
        this.setState({ info: _info, showInfo: true });
      }
      if (!(0, _lodash.isEqual)(this.props.user, nextProps.user) && nextProps.user !== null || this.props.updateUserSuccess !== nextProps.updateUserSuccess && nextProps.updateUserSuccess) {
        // TODO: đăng nhập thành công
        this.nextStep();
      }
      if (!(0, _lodash.isEqual)(this.props.bookingSuccess, nextProps.bookingSuccess) && nextProps.bookingSuccess) {
        // TODO: Success
        var bookingSuccess = nextProps.bookingSuccess,
            changeBooking = nextProps.changeBooking;

        var _title2 = { text: 'Đặt chỗ thành công', type: 'success' };
        var _message2 = [{ text: bookingSuccess.message }];
        var _button2 = [{
          type: 'default',
          text: 'Chi Tiết Đặt Chỗ',
          onClick: function onClick() {
            return _this3.toBookingDetail(bookingSuccess.bookingRequestId);
          }
        }, {
          text: 'Trang Chủ',
          onClick: function onClick() {
            return _this3.props.history.push('/');
          }
        }];
        var backdrop = 'static';
        var _info2 = { title: _title2, message: _message2, button: _button2, closeButton: false };
        changeBooking('backBookingSuccess', true);
        this.setState({ info: _info2, showInfo: true, backdrop: backdrop });
      }
    }
  }, {
    key: 'toBookingDetail',
    value: function toBookingDetail(bookingRequestId) {
      var history = this.props.history;

      if (bookingRequestId) {
        // history.go(-3);
        history.push('/lich-hen/' + bookingRequestId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./StepThree.scss');
      var _state = this.state,
          FooterUI = _state.FooterUI,
          previewData = _state.previewData,
          showBill = _state.showBill,
          showInfo = _state.showInfo,
          info = _state.info,
          backdrop = _state.backdrop;
      var _props3 = this.props,
          _props3$submit = _props3.submit,
          atHome = _props3$submit.atHome,
          userInfo = _props3$submit.userInfo,
          district = _props3$submit.district,
          province = _props3$submit.province,
          shop = _props3$submit.shop,
          bill = _props3.pricing,
          user = _props3.user,
          provinces = _props3.provinces,
          districts = _props3.districts,
          provinceActive = _props3.provinceActive,
          districtActive = _props3.districtActive,
          addressActive = _props3.addressActive;

      var disabledHomeService = atHome ? !district || !province || !addressActive : false;
      var disabled = !userInfo.name || !userInfo.phone || disabledHomeService;
      var tracking = this.trackingData();
      var token = (0, _localStorage.localStore)().get('token');
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'div',
            { className: styles.label },
            _react2.default.createElement(
              'label',
              null,
              'Vui l\xF2ng ki\u1EC3m tra k\u1EF9 th\xF4ng tin tr\u01B0\u1EDBc khi x\xE1c nh\u1EADn'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.block },
            _react2.default.createElement(_components.PreviewBooking, {
              className: styles.preview,
              data: previewData,
              onClick: this.showBill
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.block },
            _react2.default.createElement(_components.ContactInfo, {
              data: (0, _extends3.default)({}, userInfo, {
                isFreelance: shop.shopType === 'freelance',
                provinces: provinces,
                districts: districts,
                atHome: atHome,
                address: addressActive,
                province: provinceActive,
                district: districtActive
              }),
              onChange: this.onChangeContact,
              onChangeProvince: this.props.changeProvinceBooking,
              onChangeDistrict: this.props.changeDistrictBooking,
              onChangeAddress: this.props.changeAddressBooking
            })
          )
        ),
        !!(token && user && user.verifiedPhone) && _react2.default.createElement(_components.FooterBooking, {
          tracking: tracking,
          manualTrack: this.props.manualTrack,
          data: FooterUI,
          onClick: this.nextStep
        }),
        !!(token && user && !user.verifiedPhone) && _react2.default.createElement(
          _FirebaseAuth2.default,
          {
            disabled: disabled,
            onResponse: this.responseActivePhone,
            phone: userInfo && userInfo.phone,
            isBooking: true
          },
          function (p) {
            return _react2.default.createElement(
              'div',
              { className: styles.btnBox },
              _react2.default.createElement(
                'button',
                (0, _extends3.default)({}, p, {
                  className: styles.btn + ' ' + (disabled ? styles.disabled : '')
                }),
                _react2.default.createElement(
                  'span',
                  null,
                  'X\xE1c Nh\u1EADn'
                )
              )
            );
          }
        ),
        !(token && user) && _react2.default.createElement(
          _FirebaseAuth2.default,
          {
            disabled: disabled,
            phone: userInfo && userInfo.phone,
            onResponse: this.responsePhone,
            isBooking: true
          },
          function (p) {
            return _react2.default.createElement(
              'div',
              { className: styles.btnBox },
              _react2.default.createElement(
                'button',
                (0, _extends3.default)({}, p, {
                  className: styles.btn + ' ' + (disabled ? styles.disabled : '')
                }),
                'X\xE1c Nh\u1EADn'
              )
            );
          }
        ),
        _react2.default.createElement(
          _components.ModalCustom,
          { key: 'bill', show: showBill, onHide: this.hideBill },
          _react2.default.createElement(_components.Bill, { data: bill, onClose: this.hideBill })
        ),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'info',
          show: showInfo,
          onHide: this.hideInfo,
          title: info.title,
          message: info.message,
          button: info.button,
          backdrop: backdrop,
          closeButton: info.closeButton
        })
      );
    }
  }]);
  return StepThree;
}(_react.Component), _class2.propTypes = {
  // @data
  provinces: _react.PropTypes.array,
  districts: _react.PropTypes.array,
  provinceActive: _react.PropTypes.object,
  districtActive: _react.PropTypes.object,
  addressActive: _react.PropTypes.string,
  submit: _react.PropTypes.object,
  pricing: _react.PropTypes.object,
  user: _react.PropTypes.object,
  bookingSuccess: _react.PropTypes.object,
  bookingError: _react.PropTypes.object,
  history: _react.PropTypes.object,
  updateUserError: _react.PropTypes.object,
  ANALYTIC_EXTRA: _react.PropTypes.object,
  updateUserSuccess: _react.PropTypes.bool,
  // @action
  changeContact: _react.PropTypes.func,
  submitBooking: _react.PropTypes.func,
  changeBooking: _react.PropTypes.func,
  loginVerifyBooking: _react.PropTypes.func,
  activePhone: _react.PropTypes.func,
  loadAuth: _react.PropTypes.func,
  changeProvinceBooking: _react.PropTypes.func,
  changeDistrictBooking: _react.PropTypes.func,
  changeAddressBooking: _react.PropTypes.func,
  loadDistrictBooking: _react.PropTypes.func,
  manualTrack: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = StepThree;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Booking/StepThree.js
// module id = 1535
// module chunks = 0